import { ResolutionConverter } from '../Colorizer/ResolutionConverter';

export const getValuesIncludingInfinityFromSliderOutput = (
    currentValue1: number | false,
    currentValue2: number | false,
    resolutionConverter: ResolutionConverter
) => {
    let values: (string | null)[] = [];
    if (currentValue1 === false && currentValue2 !== false) {
        values = [null, resolutionConverter.getFormatted(currentValue2)];
    } else if (currentValue2 === false && currentValue1 !== false) {
        values = [resolutionConverter.getFormatted(currentValue1), null];
    } else if (currentValue1 !== false && currentValue2 !== false) {
        values = [
            resolutionConverter.getFormatted(currentValue1),
            resolutionConverter.getFormatted(currentValue2),
        ];
    }
    console.log(
        'time-period, getValuesIncludingInfinityFromSliderOutput, values',
        values,
        resolutionConverter.getResolution()
    );
    return values;
};
